"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _createForOfIteratorHelper = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _regeneratorRuntime = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _createSuper = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _inherits = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BaseTask_1 = require("./BaseTask");
/*
 * [[CreatePeerConnectionTask]] sets up the peer connection object.
 */


var CreatePeerConnectionTask = /*#__PURE__*/function (_BaseTask_1$default) {
  _inherits(CreatePeerConnectionTask, _BaseTask_1$default);

  var _super = _createSuper(CreatePeerConnectionTask);

  function CreatePeerConnectionTask(context) {
    var _this;

    _classCallCheck(this, CreatePeerConnectionTask);

    _this = _super.call(this, context.logger);
    _this.context = context;
    _this.taskName = 'CreatePeerConnectionTask';
    _this.removeTrackAddedEventListener = null;
    _this.removeTrackRemovedEventListeners = {};
    _this.trackEvents = ['ended', 'mute', 'unmute', 'isolationchange', 'overconstrained'];
    _this.removeVideoTrackEventListeners = {};

    _this.trackAddedHandler = function (event) {
      var track = event.track;

      _this.context.logger.info("received track event: kind=".concat(track.kind, " id=").concat(track.id, " label=").concat(track.label));

      if (event.transceiver && event.transceiver.currentDirection === 'inactive') {
        return;
      }

      if (event.streams.length === 0) {
        _this.context.logger.warn("Track event but no stream");

        return;
      }

      var stream = event.streams[0];

      if (track.kind === 'audio') {
        _this.context.audioMixController.bindAudioStream(stream);
      } else if (track.kind === 'video' && !_this.trackIsVideoInput(track)) {
        _this.addRemoteVideoTrack(track, stream);
      }
    };

    return _this;
  }

  _createClass(CreatePeerConnectionTask, [{
    key: "removeObserver",
    value: function removeObserver() {
      this.removeTrackAddedEventListener && this.removeTrackAddedEventListener();

      for (var trackId in this.removeTrackRemovedEventListeners) {
        this.removeTrackRemovedEventListeners[trackId]();
      }
    }
  }, {
    key: "addPeerConnectionEventLogger",
    value: function addPeerConnectionEventLogger() {
      var _this2 = this;

      var peer = this.context.peer;
      peer.addEventListener('connectionstatechange', function () {
        _this2.context.logger.info("peer connection state changed: ".concat(peer.connectionState));
      });
      peer.addEventListener('negotiationneeded', function () {
        _this2.context.logger.info('peer connection negotiation is needed');
      });
      peer.addEventListener('icegatheringstatechange', function () {
        _this2.context.logger.info("peer connection ice gathering state changed: ".concat(peer.iceGatheringState));
      });
      peer.addEventListener('icecandidate', function (event) {
        _this2.context.logger.info("peer connection ice candidate: ".concat(event.candidate ? event.candidate.candidate : '(null)'));
      });
      peer.addEventListener('iceconnectionstatechange', function () {
        _this2.context.logger.info("peer connection ice connection state changed: ".concat(peer.iceConnectionState));
      });
    }
  }, {
    key: "run",
    value: function run() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this3 = this;

        var hasTurnCredentials, configuration, connectionConstraints;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.context.removableObservers.push(this);
                hasTurnCredentials = this.context.turnCredentials && this.context.turnCredentials.uris.length > 0;
                configuration = hasTurnCredentials ? {
                  iceServers: [{
                    urls: this.context.turnCredentials.uris,
                    username: this.context.turnCredentials.username,
                    credential: this.context.turnCredentials.password,
                    credentialType: 'password'
                  }],
                  iceTransportPolicy: 'relay'
                } : {};
                configuration.bundlePolicy = this.context.browserBehavior.requiresBundlePolicy(); // @ts-ignore

                configuration.sdpSemantics = this.context.browserBehavior.requiresUnifiedPlan() ? 'unified-plan' : 'plan-b'; // @ts-ignore

                this.logger.info("SDP semantics are ".concat(configuration.sdpSemantics));
                connectionConstraints = {
                  optional: [{
                    googCpuOveruseDetection: false
                  }, {
                    googCombinedAudioVideoBwe: true
                  }]
                };

                if (this.context.peer) {
                  this.context.logger.info('reusing peer connection');
                } else {
                  this.context.logger.info('creating new peer connection'); // @ts-ignore

                  this.context.peer = new RTCPeerConnection(configuration, connectionConstraints);
                  this.addPeerConnectionEventLogger();
                }

                this.removeTrackAddedEventListener = function () {
                  if (_this3.context.peer) {
                    _this3.context.peer.removeEventListener('track', _this3.trackAddedHandler);
                  }

                  _this3.removeTrackAddedEventListener = null;
                };

                this.context.peer.addEventListener('track', this.trackAddedHandler);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "trackIsVideoInput",
    value: function trackIsVideoInput(track) {
      if (this.context.transceiverController.useTransceivers()) {
        this.logger.debug(function () {
          return "getting video track type (unified-plan)";
        });
        return this.context.transceiverController.trackIsVideoInput(track);
      }

      this.logger.debug(function () {
        return "getting video track type (plan-b)";
      });

      if (this.context.activeVideoInput) {
        var tracks = this.context.activeVideoInput.getVideoTracks();

        if (tracks && tracks.length > 0 && tracks[0].id === track.id) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "addRemoteVideoTrack",
    value: function addRemoteVideoTrack(track, stream) {
      var _this4 = this;

      var _a;

      var trackId = stream.id;

      if (!this.context.browserBehavior.requiresUnifiedPlan()) {
        stream = new MediaStream([track]);
        trackId = track.id;
      }

      var attendeeId = this.context.videoStreamIndex.attendeeIdForTrack(trackId);
      var skipAdding;
      var tile;

      if (this.context.videoTileController.getVideoTileForAttendeeId) {
        tile = this.context.videoTileController.getVideoTileForAttendeeId(attendeeId);
        skipAdding = !!((_a = tile === null || tile === void 0 ? void 0 : tile.state()) === null || _a === void 0 ? void 0 : _a.boundVideoStream);
      } else {
        skipAdding = this.context.videoTileController.haveVideoTileForAttendeeId(attendeeId);
      }

      if (skipAdding) {
        this.context.logger.info("Not adding remote track. Already have tile for attendeeId:  ".concat(attendeeId));
        return;
      }

      if (!tile) {
        tile = this.context.videoTileController.addVideoTile();
        this.logger.info("Created video tile ".concat(tile.id()));
      }

      var streamId = this.context.videoStreamIndex.streamIdForTrack(trackId);

      if (typeof streamId === 'undefined') {
        this.logger.warn("stream not found for tile=".concat(tile.id(), " track=").concat(trackId));
        streamId = null;
      }

      var _loop = function _loop(i) {
        var trackEvent = _this4.trackEvents[i];
        var videoTracks = stream.getVideoTracks();

        if (videoTracks && videoTracks.length) {
          var videoTrack = videoTracks[0];

          var callback = function callback() {
            _this4.context.logger.info("received the ".concat(trackEvent, " event for tile=").concat(tile.id(), " id=").concat(track.id, " streamId=").concat(streamId));

            if (trackEvent === 'ended' && _this4.context.browserBehavior.requiresUnifiedPlan()) {
              _this4.removeRemoteVideoTrack(track, tile.state());
            }
          };

          videoTrack.addEventListener(trackEvent, callback);

          if (!_this4.removeVideoTrackEventListeners[track.id]) {
            _this4.removeVideoTrackEventListeners[track.id] = [];
          }

          _this4.removeVideoTrackEventListeners[track.id].push(function () {
            videoTrack.removeEventListener(trackEvent, callback);
          });
        }
      };

      for (var i = 0; i < this.trackEvents.length; i++) {
        _loop(i);
      }

      var width;
      var height;

      if (track.getSettings) {
        var cap = track.getSettings();
        width = cap.width;
        height = cap.height;
      } else {
        var _cap = track.getCapabilities();

        width = _cap.width;
        height = _cap.height;
      }

      var externalUserId = this.context.videoStreamIndex.externalUserIdForTrack(trackId);
      tile.bindVideoStream(attendeeId, false, stream, width, height, streamId, externalUserId);
      this.logger.info("video track added, use tile=".concat(tile.id(), " track=").concat(trackId, " streamId=").concat(streamId));
      var endEvent = 'removetrack';
      var target = stream;

      if (!this.context.browserBehavior.requiresUnifiedPlan()) {
        this.logger.debug(function () {
          return 'updating end event and target track (plan-b)';
        });
        endEvent = 'ended'; // @ts-ignore

        target = track;
      }

      var trackRemovedHandler = function trackRemovedHandler() {
        return _this4.removeRemoteVideoTrack(track, tile.state());
      };

      this.removeTrackRemovedEventListeners[track.id] = function () {
        target.removeEventListener(endEvent, trackRemovedHandler);
        delete _this4.removeTrackRemovedEventListeners[track.id];
      };

      target.addEventListener(endEvent, trackRemovedHandler);
    }
  }, {
    key: "removeRemoteVideoTrack",
    value: function removeRemoteVideoTrack(track, tileState) {
      if (this.removeTrackRemovedEventListeners.hasOwnProperty(track.id)) {
        this.removeTrackRemovedEventListeners[track.id]();

        var _iterator = _createForOfIteratorHelper(this.removeVideoTrackEventListeners[track.id]),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var removeVideoTrackEventListener = _step.value;
            removeVideoTrackEventListener();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        delete this.removeVideoTrackEventListeners[track.id];
      }

      this.logger.info("video track ended, removing tile=".concat(tileState.tileId, " id=").concat(track.id, " stream=").concat(tileState.streamId));

      if (tileState.streamId) {
        this.context.videosPaused.remove(tileState.streamId);
      } else {
        this.logger.warn("no stream found for tile=".concat(tileState.tileId));
      }

      this.context.videoTileController.removeVideoTile(tileState.tileId);
    }
  }]);

  return CreatePeerConnectionTask;
}(BaseTask_1.default);

exports.default = CreatePeerConnectionTask;
CreatePeerConnectionTask.REMOVE_HANDLER_INTERVAL_MS = 10000;